import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'
import { useState, useMemo } from 'react'
import { BasicPlayer, useAllPlayers } from './api'
import Header from '../common/components/header/Header'
import TeamsPlayersHeader from '../common/components/header/TeamsPlayersHeader'
import Meta from '../common/Meta'
import PlayerCard from './PlayerCard'
import RowData from '../common/components/row/RowData'
import classes from './Players.module.css'
import { LeaguestarState } from '../state'
import { Text } from '@mantine/core'
import { Link, useLocation, useParams } from 'react-router'

export default function Players() {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const location = useLocation()
  const { competitionId } = useParams()
  const { data: players } = useAllPlayers({
    competition_id: Number(competitionId),
  })
  const [searchValue, setSearchValue] = useState('')
  const { players_layout } = LeaguestarState.useState((state) => ({
    players_layout: state.players_layout,
  }))

  const filteredPlayers = useMemo(() => {
    if (!searchValue.trim()) return players.items
    const search = searchValue.toLowerCase()
    return players.items.filter((player) =>
      player.name.toLowerCase().includes(search)
    )
  }, [players, searchValue])

  function setPlayersLayout(layout: 'grid' | 'list') {
    LeaguestarState.update((state) => {
      state.players_layout = layout
    })
    localStorage.setItem('players_layout', layout)
  }

  return (
    <div className={classes.container}>
      <Meta title="Players" />
      <Header title="Players" />
      <div
        className={clsx(classes.players_wrapper, {
          [classes.players_wrapper_mobile]: !isDesktop,
        })}
      >
        <TeamsPlayersHeader
          title="Players"
          layout={players_layout}
          setLayout={setPlayersLayout}
          searchValue={searchValue}
          onSearchChange={setSearchValue}
        />
        {players_layout === 'grid' && (
          <div className={classes.players_grid}>
            {filteredPlayers.length > 0 ? (
              filteredPlayers.map((player: BasicPlayer) => (
                <Link
                  key={player.player_id}
                  to={`/competitions/${competitionId}/players/${player.player_id}`}
                  state={{ from: location }}
                  className={classes.link}
                >
                  <PlayerCard key={player.player_id} player={player} />
                </Link>
              ))
            ) : (
              <Text
                size="sm"
                c="dimmed"
                style={{
                  gridColumn: '1 / -1',
                  textAlign: 'center',
                  padding: '2rem',
                }}
              >
                No players found matching "{searchValue}"
              </Text>
            )}
          </div>
        )}
        {players_layout === 'list' && (
          <div className={classes.players_list}>
            {filteredPlayers.length > 0 ? (
              filteredPlayers.map((player: BasicPlayer) => (
                <Link
                  key={player.player_id}
                  to={`/competitions/${competitionId}/players/${player.player_id}`}
                  state={{ from: location }}
                  className={classes.link}
                >
                  <RowData
                    player_name={player.name}
                    player_image={player.photo.thumbnail}
                    team_logo={player.team_logo.thumbnail}
                  />
                </Link>
              ))
            ) : (
              <Text
                size="sm"
                c="dimmed"
                style={{ textAlign: 'center', padding: '2rem' }}
              >
                No players found matching "{searchValue}"
              </Text>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
